function handleResponse() {
    let html = JSON.parse(this.responseText);
    document.querySelector("div#shopify-section-cart-drawer").outerHTML = html['cart-drawer'];
    document.querySelector("cart-drawer").classList.add("active");
    document.querySelector("cart-drawer").classList.remove("is-empty");

    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            if (cart.items.length === 1) {
                let cartItem = cart.items[0];
                let productTitle = cartItem.product_title.toLowerCase().trim();

                if (productTitle === "gift wrapping") {
                    let line = 1;

                    fetch('/cart/change.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ line: line, quantity: 0 })
                    })
                        .then(response => response.json())
                        .then(() => window.location.reload())
                        .catch(error => console.error("Error removing Gift Wrapping:", error));
                }
            }
        })
        .catch(error => console.error("Error fetching cart:", error));
}

document.addEventListener("DOMContentLoaded", function () {
    $(document).on('click', function (evt) {
        if ($(evt.target).closest(".add-wrapper-upsell, .add-wrapper-upsell svg").length) {
            evt.preventDefault();
            let key = $(evt.target).closest("[data-line]").data("line");
            const popup = $(`.ACC_JackiesKids_CartDrawer_26_wrapper_popup[data-popup-key="${key}"]`);
            if (popup.length) {
                popup.toggleClass("ACC_JackiesKids_CartDrawer_26_wrapper_popup_hide");
            }
        }
    });

    document.addEventListener("click", function (evt) {
        if (evt.target && evt.target.closest(".ACC_JackiesKids_CartDrawer_26_col_variant")) {
            const clickedVariant = evt.target.closest(".ACC_JackiesKids_CartDrawer_26_col_variant");
            const allVariants = clickedVariant.closest(".ACC_JackiesKids_CartDrawer_26_wrapper_popup_subheading_variant")
                .querySelectorAll(".ACC_JackiesKids_CartDrawer_26_col_variant");

            allVariants.forEach(variant => {
                variant.classList.remove("ACC_JackiesKids_CartDrawer_26_col_variant_active");
            });

            clickedVariant.classList.add("ACC_JackiesKids_CartDrawer_26_col_variant_active");
        }
    });

    $("body").on("click", ".ACC_JackiesKids_CartDrawer_26_wrapper_popup_close", function () {
        $(".ACC_JackiesKids_CartDrawer_26_wrapper_popup").addClass("ACC_JackiesKids_CartDrawer_26_wrapper_popup_hide");
    });

    $("body").on("click", ".add-wrapper-upsell-img-close", async function () {
        $("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
        $("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
        $("div#CartDrawer-Overlay").addClass("disabledCheckout");

        let id = $(this).attr("data-quantity-variant-id");
        let n = parseInt($(`.quantity__input[data-quantity-variant-id=${id}]`).val()) - parseInt($(this).attr("data-n"));
        let key = $(this).attr("data-key");
        let mainquan = $(this).attr("data-n");
        let formData = new FormData();
        formData.append(`updates[${id}]`, n);

        await fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            body: formData
        })
            .then(response => response.json())
            .then(async () => {
                let updates = {
                    id: key,
                    properties: { Cover: "" },
                    quantity: mainquan
                };

                await fetch(window.Shopify.routes.root + 'cart/change.js?gift=true', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(updates)
                })
                    .then(response => response.json())
                    .then(() => {
                        const request = new XMLHttpRequest();
                        request.addEventListener('load', handleResponse);
                        request.open('GET', '/?sections=cart-drawer', true);
                        request.send();
                    })
                    .catch(error => console.error('Error:', error));
            });
    });

    $("body").on("click", ".ACC_JackiesKids_CartDrawer_26_wrapper_popup_atc_section_btn", async function (e) {
        e.preventDefault();
        let $activeVariant = $(this).parent().prev().find(".ACC_JackiesKids_CartDrawer_26_col_variant_active");
        let id = $activeVariant.attr("data-quantity-variant-id");
        let title = $activeVariant.attr("data-title");
        let n = $(this).attr('data-quantity');
        let mainid = this.getAttribute('data-atc-id');

        $("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
        $("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
        $("div#CartDrawer-Overlay").addClass("disabledCheckout");

        let formData = {
            items: [{ id: id, quantity: n }]
        };

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(async (res) => {
                if (res.items.length > 0) {
                    let updates = {
                        id: mainid,
                        properties: { Cover: title },
                        quantity: n
                    };

                    await fetch(window.Shopify.routes.root + 'cart/change.js?gift=true', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(updates)
                    })
                        .then(response => response.json())
                        .then(() => {
                            const request = new XMLHttpRequest();
                            request.addEventListener('load', handleResponse);
                            request.open('GET', '/?sections=cart-drawer', true);
                            request.send();
                        })
                        .catch(error => console.error('Error:', error));
                }
            })
            .catch(error => console.error('Error:', error));
    });
});

function refreshCart() {
    let updates = {};

    $(".cart-item--product-gift-wrapping").each(function () {
        let title = $(this).attr("data-title");
        let id = $(this).attr("data-id");
        let value = (title === 'christmas')
            ? $("button#CartDrawer-Checkout").attr("data-christmas") || 0
            : $("button#CartDrawer-Checkout").attr("data-silver") || 0;

        updates[id] = value;
    });

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    })
        .then(response => response.json())
        .then(() => {
            const request = new XMLHttpRequest();
            request.addEventListener('load', handleResponse);
            request.open('GET', '/?sections=cart-drawer', true);
            request.send();
        })
        .catch(error => console.error('Error:', error));
}

let debounceTimeout;

function debounceRefreshCart() {
    clearTimeout(debounceTimeout);
    $("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
    $("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
    $("div#CartDrawer-Overlay").addClass("disabledCheckout");
    debounceTimeout = setTimeout(refreshCart, 1100);
}

function openCart() {
    const request = new XMLHttpRequest();
    request.addEventListener('load', handleResponse);
    request.open('GET', '/?sections=cart-drawer', true);
    request.send();
}

new PerformanceObserver(function (e) {
    !e.getEntriesByType("resource").some(({ name }) => /\/cart\/change(?=\s|$)/i.test(name)) || debounceRefreshCart();
}).observe({ entryTypes: ["resource"] });

new PerformanceObserver(function (e) {
    !e.getEntriesByType("resource").some(({ name }) => /\/cart\/(add)/i.test(name)) || openCart();
}).observe({ entryTypes: ["resource"] });

$('body').on('click', '.cart-drawer-item__cart-remove-button', function () {
    setTimeout(() => {
        if ($('.drawer__inner-empty').length) {
            refreshSlider();
        }
    }, 1500);
});

function refreshSlider() {
    const divs = document.querySelectorAll(".oi-cart-upsell-product");
    const nextButton = document.querySelector(".ACC_JackiesKids_CartDrawer_35-swiper_button_next");
    const prevButton = document.querySelector(".ACC_JackiesKids_CartDrawer_35-swiper_button_prev");

    nextButton.addEventListener("click", function () {
        let activeIndex = -1;
        divs.forEach((div, index) => {
            if (div.classList.contains("oi-active-tab")) activeIndex = index;
        });

        if (activeIndex !== -1) {
            divs[activeIndex].classList.remove("oi-active-tab");
            let nextIndex = (activeIndex + 1) % divs.length;
            divs[nextIndex].classList.add("oi-active-tab");
        }
    });

    prevButton.addEventListener("click", function () {
        let activeIndex = -1;
        divs.forEach((div, index) => {
            if (div.classList.contains("oi-active-tab")) activeIndex = index;
        });

        if (activeIndex !== -1) {
            divs[activeIndex].classList.remove("oi-active-tab");
            let prevIndex = (activeIndex - 1 + divs.length) % divs.length;
            divs[prevIndex].classList.add("oi-active-tab");
        }
    });
}

document.addEventListener("DOMContentLoaded", function () {
    refreshSlider();
});
